export default __webpack_public_path__ + "static/media/chat-sms-svgrepo-com.c01e1069.svg";